/* WheelX : couleurs fluo (jaune, orange) pour cerclages et moyeux, au prix du blanc. Patch le source du configurateur au chargement. */
(function(){
  window.WXWH=function(n){return n==="Blanc"||n==="Jaune fluo"||n==="Orange fluo"};
  window.WXfluo=function(m,a,b,h){[["MAT_Cerclage",a],["MAT_Cerclage_2",b],["MAT_Moyeu",h]].forEach(function(z){var q=m[z[0]];if(!q||!q.emissive)return;if(z[1]==="Jaune fluo"||z[1]==="Orange fluo")q.emissive.copy(q.color).multiplyScalar(.42);else q.emissive.setRGB(0,0,0)})};
  var FL=[
    [/\["Violet","#CC00FF"\],\["Blanc","#FFFFFF"\],\["RGB","rgb"\]\]/,'["Violet","#CC00FF"],["Blanc","#FFFFFF"],["Jaune fluo","#E4FF00"],["Orange fluo","#FC3301"],["RGB","rgb"]]'],
    [/\["Bleu clair","#0084FF"\],\["Or","#FFC300"\],\["Bronze","#916D55"\],\["Aluminium","#B9B9B9"\]/,'["Bleu clair","#0084FF"],["Bleu turquoise","#00D4C8"],["Or","#FFC300"],["Bronze","#916D55"],["Aluminium","#B9B9B9"]'],
    [/(pal\(k(?:\+"2")?\)\[S\[k(?:\+"2")?\]\]\[0\])===\"Blanc\"/g,function(m0,v){return'window.WXWH('+v+')'}],
    [/\b(o\d?)\[0\]===\"Blanc\"/g,function(m0,v){return'window.WXWH('+v+'[0])'}],
    [/\b(n1|n2b|nh)===\"Blanc\"/g,function(m0,v){return'window.WXWH('+v+')'}],
    [/\bnh!==\"Blanc\"/g,'!window.WXWH(nh)'],
    [/LIGHT=\[\"Blanc\",/,'LIGHT=["Blanc","Jaune fluo","Bleu turquoise",'],
    [/m\.MAT_Decalco_blanche&&m\.MAT_Decalco_blanche\.color\.set\(lt\(n1\)/,function(m0){return'window.WXfluo&&window.WXfluo(m,n1,n2b,nh),'+m0}],
    [/Blanc ou N[^o]{1,6}ochrome : \+ 49,90/,'Blanc, Jaune fluo, Orange fluo ou N\\xE9ochrome : + 49,90'],
    [/Blanc \(peinture\) : \+ 29,90/,'Blanc, Jaune fluo, Orange fluo (peinture) : + 29,90']
  ];

  var X=window.XMLHttpRequest;if(!X)return;var op=X.prototype.open,sd=X.prototype.send;
  X.prototype.open=function(m,u){this._wxu=String(u||"");return op.apply(this,arguments)};
  X.prototype.send=function(){
    var r=sd.apply(this,arguments);
    try{if(/wheelx-app\.js/.test(this._wxu||"")&&this.status===200){
      var s=this.responseText,t=s;
      FL.forEach(function(p){p[0].lastIndex=0;if(p[0].test(t)){p[0].lastIndex=0;t=t.replace(p[0],function(){return typeof p[1]==="function"?p[1].apply(null,arguments):p[1]})}});
      if(t!==s)Object.defineProperty(this,"responseText",{value:t,configurable:true});
    }}catch(e){}
    return r;
  };
})();